/* =============================================================================
   kfz-cart.js - Bedienung des Warenkorbs (sections/kfz-warenkorb.liquid).
   Laeuft auf der Warenkorbseite und im Seitenfenster (snippets/kfz-cart-drawer):
   beide zeigen dasselbe Markup, nur an anderer Stelle.

   Braucht kfz-districts.js, kfz-config.js, kfz-validate.js und
   kfz-plate-layout.js davor.

   KfzCart.mount(root, options)
     root    : das .kfzw-Element. Es traegt alles, was die Datei wissen muss:
               id="kfzw-<section.id>", data-cart-url, data-add-url,
               data-update-url, data-asset-base.
     options : { onReload: function } - wird gerufen, wenn sich der Warenkorb
               nicht Stueck fuer Stueck aktualisieren laesst (leer geworden).
               Ohne Angabe laedt die Seite neu.
   ========================================================================== */
var KfzCart = (function () {
  'use strict';

  function updateHeaderCount(count) {
    var links = document.querySelectorAll('.kfzc-cart:not(.kfzc-account)');
    for (var i = 0; i < links.length; i++) {
      var bubble = links[i].querySelector('.kfzc-cart-count');
      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('span');
          bubble.className = 'kfzc-cart-count';
          links[i].appendChild(bubble);
        }
        bubble.textContent = count;
      } else if (bubble) {
        bubble.remove();
      }
    }
  }

  // --- Vorschau --------------------------------------------------------------
  // Fuellt die schreibgeschuetzten Felder mit dem gespeicherten Stand und legt
  // sie mit derselben Geometrie aus wie der Konfigurator.
  function drawPlates(scope, assetBase) {
    if (typeof KfzPlateLayout === 'undefined') { return; }
    if (assetBase) { PlateConfig.ASSET_BASE = assetBase; }
    var plates = scope.querySelectorAll('.ss-editable[data-kfz]');
    for (var i = 0; i < plates.length; i++) {
      var editable = plates[i];
      var saved;
      try { saved = JSON.parse(editable.getAttribute('data-kfz')); } catch (e) { continue; }
      var fields = { '.kfz-input--city': saved.city, '.kfz-input--letters': saved.letters, '.kfz-input--digits': saved.digits, '.kfz-input--parking': saved.parking };
      for (var selector in fields) {
        var input = editable.querySelector(selector);
        if (input) { input.value = fields[selector] || ''; }
      }
      var trimmed = KfzPlateLayout.apply(editable, {
        cityCode: saved.city || '',
        letters: saved.letters || '',
        digits: saved.digits || '',
        parkingText: saved.parking || '',
        sizeId: saved.size,
        type: saved.type,
        seasonFrom: saved.from || '',
        seasonTo: saved.to || ''
      }, { finish: saved.finish });
      editable.dataset.ready = '';
      // Nie still etwas anderes zeigen als bestellt: passt die gespeicherte
      // Eingabe nicht, bleibt sie sichtbar gekuerzt und die Zeile warnt.
      var item = editable.closest('[data-kfzw-item]');
      var warn = item ? item.querySelector('[data-kfzw-trimmed]') : null;
      if (warn) { warn.hidden = !trimmed; }
    }
  }

  function mount(root, options) {
    if (!root || root.hasAttribute('data-kfzw-mounted') || root.hasAttribute('data-empty')) { return; }
    root.setAttribute('data-kfzw-mounted', '');
    options = options || {};

    var sectionId = root.id.replace(/^kfzw-/, '');
    var assetBase = root.getAttribute('data-asset-base') || '';
    var urls = {
      cart: root.getAttribute('data-cart-url') || '/cart',
      add: root.getAttribute('data-add-url') || '/cart/add.js',
      update: root.getAttribute('data-update-url') || '/cart/update.js'
    };
    var reload = options.onReload || function () { window.location.reload(); };
    var busy = false;

    function showError(message) {
      var slot = root.querySelector('[data-kfzw-error]');
      if (slot) { slot.textContent = message || ''; }
    }

    // --- Anfragen ------------------------------------------------------------
    // Der Shop rechnet, die Seite zeigt nur, was er zurueckgibt: jede Aenderung
    // holt den Warenkorb und die Uebersicht per Section Rendering neu.
    function send(url, body, busyNode, focusKey) {
      if (busy) { return; }
      busy = true;
      showError('');
      root.setAttribute('aria-busy', 'true');
      if (busyNode) { busyNode.classList.add('is-loading'); }
      body.sections = sectionId;
      body.sections_url = urls.cart;

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) { throw data; }
          return data;
        });
      }).then(function (data) {
        var html = data.sections && data.sections[sectionId];
        if (!html) { reload(); return; }
        var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('kfzw-' + sectionId);
        updateHeaderCount(fresh ? parseInt(fresh.getAttribute('data-count'), 10) || 0 : 0);
        // Leer geworden: ganz neu aufbauen (Seite oder Fenster).
        if (!fresh || fresh.hasAttribute('data-empty')) { reload(); return; }
        ['[data-kfzw-cart]', '[data-kfzw-overview]'].forEach(function (selector) {
          var current = root.querySelector(selector);
          var next = fresh.querySelector(selector);
          if (current && next) { current.replaceWith(next); }
        });
        drawPlates(root, assetBase);
        var target = focusKey ? root.querySelector('[data-focus="' + focusKey + '"]') : null;
        target = target || root.querySelector('[data-kfzw-title]');
        if (target) { target.focus({ preventScroll: !!options.preventScroll }); }
      }).catch(function (error) {
        if (busyNode) { busyNode.classList.remove('is-loading'); }
        showError((error && (error.description || error.message)) || 'Das hat nicht geklappt. Bitte versuche es erneut.');
      }).then(function () {
        busy = false;
        root.removeAttribute('aria-busy');
      });
    }

    function keysOf(node) {
      try { return JSON.parse(node.getAttribute('data-links') || '[]'); } catch (e) { return []; }
    }

    // --- Bedienung -----------------------------------------------------------
    root.addEventListener('change', function (event) {
      var select = event.target.closest('[data-kfzw-qty]');
      if (!select) { return; }
      var quantity = parseInt(select.value, 10) || 1;
      var updates = {};
      updates[select.getAttribute('data-key')] = quantity;
      // Zubehoer "je Kennzeichen" zieht mit: 2 Kennzeichen, 2 Halter.
      keysOf(select).forEach(function (key) { updates[key] = quantity; });
      send(urls.update, { updates: updates }, select.closest('[data-kfzw-item]'), select.getAttribute('data-focus'));
    });

    root.addEventListener('click', function (event) {
      var node = event.target.closest('[data-kfzw-remove],[data-kfzw-add],[data-kfzw-drop],[data-kfzw-info]');
      if (!node || !root.contains(node)) { return; }

      if (node.hasAttribute('data-kfzw-info')) {
        var panel = document.getElementById(node.getAttribute('aria-controls'));
        var open = node.getAttribute('aria-expanded') !== 'true';
        node.setAttribute('aria-expanded', String(open));
        if (panel) { panel.hidden = !open; }
        return;
      }

      if (node.hasAttribute('data-kfzw-remove')) {
        // Mit dem Kennzeichen geht auch sein Zubehoer.
        var removals = {};
        removals[node.getAttribute('data-key')] = 0;
        keysOf(node).forEach(function (key) { removals[key] = 0; });
        send(urls.update, { updates: removals }, node.closest('[data-kfzw-item]'), null);
        return;
      }

      if (node.hasAttribute('data-kfzw-drop')) {
        var drop = {};
        drop[node.getAttribute('data-key')] = 0;
        send(urls.update, { updates: drop }, node.closest('.kfzw-offer'), node.getAttribute('data-focus'));
        return;
      }

      var properties = { '_kfz_fuer': node.getAttribute('data-plate') };
      if (node.hasAttribute('data-per-plate')) { properties['_kfz_je_kennzeichen'] = '1'; }
      send(urls.add, {
        items: [{
          id: parseInt(node.getAttribute('data-variant'), 10),
          quantity: parseInt(node.getAttribute('data-qty'), 10) || 1,
          properties: properties
        }]
      }, node.closest('.kfzw-offer'), node.getAttribute('data-focus'));
    });

    // Esc schliesst zuerst ein offenes Info-Feld. preventDefault sagt dem
    // Seitenfenster, dass es diesmal offen bleiben soll.
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') { return; }
      var open = root.querySelectorAll('[data-kfzw-info][aria-expanded="true"]');
      if (!open.length) { return; }
      event.preventDefault();
      for (var i = 0; i < open.length; i++) { open[i].click(); }
    });

    // Doppelklick auf "Weiter zur Kasse" schickt nicht zweimal ab.
    root.addEventListener('submit', function (event) {
      var button = event.target.querySelector('.kfzw-checkout');
      if (busy) { event.preventDefault(); return; }
      if (button) { setTimeout(function () { button.disabled = true; }, 0); }
    });

    // Zurueck aus der Kasse (Seiten-Cache): Button wieder freigeben.
    window.addEventListener('pageshow', function () {
      var button = root.querySelector('.kfzw-checkout');
      if (button) { button.disabled = false; }
    });

    // Auf der Seite: wie weit oben der Warenkorb beginnt (Kopfzeile). Die
    // Styles strecken ihn damit bis zum unteren Bildschirmrand.
    if (!root.closest('#kfzw-drawer')) {
      var setTop = function () {
        root.style.setProperty('--kfzw-top', Math.max(0, Math.round(root.getBoundingClientRect().top + window.scrollY)) + 'px');
      };
      setTop();
      window.addEventListener('resize', setTop);
      window.addEventListener('load', setTop);
    }

    drawPlates(root, assetBase);
  }

  return { mount: mount, drawPlates: drawPlates, updateHeaderCount: updateHeaderCount };
})();
